import { Component } from 'react';
import PropTypes from 'prop-types';

import Leaflet from 'leaflet';

/**
 * Component that show an image overlay on a map
 */
class MapImageLayer extends Component {
   componentDidMount() {
                             // Create layer and add to map
      this.layer = Leaflet.imageOverlay(this.props.imageUrl, this.props.imageBounds, {
         zIndex: this.props.layerOrder
      });
      this.layer.addTo(this.props.map);
   }

   componentWillUnmount() {
      this.layer.remove();
   }

   componentDidUpdate(prevProps) {
                             // Update image layer
      if (this.props.imageUrl !== prevProps.imageUrl) {
         this.layer.setUrl(this.props.imageUrl);
      }
      if (this.props.imageBounds !== prevProps.imageBounds) {
         this.layer.setBounds(this.props.imageBounds);
      }
   }

   /**
    * renders the image overlay component
    */
   render() {
      return (null);
   }
}

MapImageLayer.propTypes = {
   /**
    * defines the layer order in the map.
    */
   layerOrder: PropTypes.number,
   /**
    * defines the map object on which to add the layer
    */
   map: PropTypes.object,
   /**
    * defines the url for the image to show in the overlay layer
    */
   imageUrl: PropTypes.string,
   /**
    * defines the bounds where the image layer will be shown
    */
   imageBounds: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number))
}
export default MapImageLayer;
